<template>
    <div class="e3-head-icon-round">
        <div class="d-flex align-items-center px-3 py-2">
            <span class="font-weight-bold text-uppercase">{{ $t('Messages') }}</span>
        </div>
        <div class="border-top">
            <template v-if="recentMessages.length">
                <button
                    v-for="message in recentMessages"
                    :key="message.id"
                    class="e3-message-list-item e3-list-item-bg-hover"
                    type="button"
                    @click="showMessage(message)">
                    <NotificationListItem :message="message"/>
                </button>
            </template>
            <EmptyListMessage v-else wrapper-class="p-2">
                {{ $t('There are no received messages') }}
            </EmptyListMessage>
        </div>
        <div class="bg-light px-3 py-2 border-top rounded-bottom">
            <router-link :to="{ name: 'messages.received' }" @click.native="routerLinkClick">
                {{ $t('Show all messages') }}
            </router-link>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {eventBus} from '@/main';
import NotificationListItem from './components/NotificationListItem.vue';

export default {

    props: {
        id: [String, Number]
    },

    data() {
        return {
            tab: 'messages'
        };
    },

    computed: {
        ...mapGetters([
            'recentMessages',
            'unreadMessages',
            'messageTypes'
        ])
    },
    methods: {
        getMessages() {
            if (!this.recentMessages.length) {
                this.$store.dispatch('GET_RECENT_MESSAGES');
            }
        },
        routerLinkClick() {
            this.$emit('close', this.id);
        },
        showMessage(message) {
            eventBus.$emit('show-message-modal', {message, tab:this.messageTypes.received});
        }
    },
    components: {
        NotificationListItem
    },

    created() {
        this.getMessages();
    }
};
</script>
